






import { Prop, Vue } from 'vue-property-decorator'
import { Element, Product } from '@/models'
import { Utils } from '@/utils'
import Component from 'vue-class-component'

@Component
export default class ModalInfoHeader extends Vue {
  @Prop({ required: true })
  private item: Product | Element

  private utils = Utils
}
